module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Waengi-5bf2894e6d594b08d848e5c6e1031cd9.svg";